import { render, staticRenderFns } from "./ConsolidatedBlackList.vue?vue&type=template&id=ef97ce5c&"
import script from "./ConsolidatedBlackList.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports